import React from 'react';
import classNames from 'classnames';
import styles from './CloseBtn.module.scss';
import { Phrases } from '../../../utilities/constants/phrases';

interface Props {
  onClick: () => void;
  className?: string;
}

const CloseBtn = ({ onClick, className }: Props) => (
  <button
    type='button'
    className={classNames(styles.closeBtn, className)}
    onClick={onClick}>
    {Phrases.CLOSE_BUTTON_LABEL}
  </button>
);

export default CloseBtn;
